<template>
  <footer>
    <div class="wrapper">
      <!--div class="bottom-img"></div-->
      <div class="nav-bottom">
        <div class="footerInfo">
          <div class="footerl">
            <a class="flogo" @click="goPageByName('main')">
              <span class="copyright">Copyright 2026 MEGA. All Rights Reserved.</span>
            </a>
          </div>
          <div class="footerr">
            <!--ul class="footerNav">
              <li @click="goPageByName('qnaWrite')">{{ $t('front.common.qna')}}</li>
              <li @click="goPageByName('notice')">{{ $t('front.common.notice')}}</li>
              <li @click="goPageByName('faq')">{{ $t('front.common.faq')}}</li>
              <li @click="goPageByName('bettingGuide')">{{ $t('front.common.bettingGuide')}}</li>
              <li @click="goPageByName('result')">{{ $t('front.common.gameResult')}}</li>
              <li @click="goPageByName('boardList')">{{ $t('front.common.board')}}</li>
            </ul-->
            <ul class="sns" v-if="siteOption">
              <li @click="siteOption['sns2Link']">
                <img src="@/assets/img/telegram.svg" />
                <span>{{siteOption['sns2']}}<em>{{siteOption['sns2Id']}}</em></span>
              </li>
              <li @click="siteOption['sns1Link']">
                <img src="@/assets/img/kakao.svg" />
                <span>{{siteOption['sns1']}}<em>{{siteOption['sns1Id']}}</em></span>
              </li>
              <li v-if="siteOption['sns3']" @click="siteOption['sns3Link']">
                <img src="@/assets/img/zalo.svg" />
                <span>{{siteOption['sns3']}}<em>{{siteOption['sns3Id']}}</em></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </footer>
  <div class="quickFoot mobile">
    <div class="quickInner clearfix">
      <div class="left">
        <a @click="goPageByName('charge')" class="beforeLink">
          <i class="fi fi-sr-wallet-income"></i>
          <p>입금</p>
        </a>
        <a @click="goPageByName('exchange')" class="beforeLink">
          <i class="fi fi-sr-wallet-arrow"></i>
          <p>출금</p>
        </a>
      </div>
      <a @click="goPageByName('main')" class="home">
        <i class="fi fi-sr-house-chimney"></i>
        <p>홈</p>
      </a>
      <div class="right">
        <a @click="goPageByName('notice')" class="beforeLink">
          <i class="fi fi-sr-exclamation"></i>
          <p>공지사항</p>
        </a>
        <a @click="goPageByName('csCenter')" class="beforeLink">
          <i class="fi fi-ss-circle-microphone"></i>
          <p>고객센터</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState([
      'siteOption'
    ])
  }
}
</script>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
